import { useHistory } from 'react-router-dom';

function BotReportCard(report) {
  const history = useHistory();

  const handleClick = () => {
    history.push(`/botreports/${report.id}`);
  };

  return (
    <div className="card border-0 shadow-sm clickable" onClick={handleClick}>
      <div className="card-body">
        <div className="mb-2" style={{ fontSize: '2.2em' }}>
          {report.count || 0}
        </div>
        <p className="mt-0 mb-0 text-truncate">{report.name}</p>
      </div>
    </div>
  );
}

export default BotReportCard;
